import { useMemo } from 'react';

import {
  SHEET_GROUP_PRINTABLES,
  PRINTABLES_LIST,
} from 'approot/lesson/lesson.constants';
import { useSheetPreviewData } from 'approot/lesson/lesson.utils';
import { LessonPrintablesFragment } from './__generated__/LessonPrintablesFragment';
import { LessonActivitiesFragment_lessonActivities_studentPrintables } from '../activities/__generated__/LessonActivitiesFragment';
import { LESSON } from 'global/constants';
import Sheets from 'approot/lesson/sheets';

type Props = {
  sheets: LessonPrintablesFragment;
  studentPrintables: LessonActivitiesFragment_lessonActivities_studentPrintables | null;
  displayAnswerSheet?: boolean;
};

const LessonPrintablesGuest = ({
  sheets: lessonSheetData,
  studentPrintables,
  displayAnswerSheet,
}: Props) => {
  const { id, __typename, ...sheets } = lessonSheetData;

  const sheetData = useSheetPreviewData(LESSON, id, sheets);
  const filteredPrintablesList = useMemo(() => {
    const sheetsList = [...PRINTABLES_LIST[sheetData.type]];
    return displayAnswerSheet
      ? sheetsList
      : sheetsList.filter(i => i.key !== 'printableAnswerSheet');
  }, [sheetData.type, displayAnswerSheet]);

  return (
    <div data-selector="printables-content-section">
      <Sheets
        fourColumnLayout
        studentPrintables={studentPrintables}
        lesson={sheetData}
        sheetDefinitions={filteredPrintablesList}
        sheetGroup={SHEET_GROUP_PRINTABLES}
      />
    </div>
  );
};

export default LessonPrintablesGuest;
